import { render, staticRenderFns } from "./PublicLayoutMain.vue?vue&type=template&id=0e4a3ae8&"
import script from "./PublicLayoutMain.vue?vue&type=script&lang=js&"
export * from "./PublicLayoutMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports